const buildHrefState = (pathname, currentLocation) => ({
  pathname,
  state: { previousLocation: currentLocation },
})

export const buildJobDetailsHref = (candidateSlug, positionId, currentLocation) =>
  buildHrefState(`/candidate/${candidateSlug}/recommended-jobs/${positionId}`, currentLocation)

export const buildInterviewRequestHref = (candidateSlug, interviewRequestId, currentLocation) =>
  buildHrefState(`/candidate/${candidateSlug}/interview_requests/${interviewRequestId}`, currentLocation)
